import { useState, useEffect } from "react";
import { Plus } from "react-feather";
import DatePicker from "react-datepicker";
// import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const AddProjectManagement = () => {
  const [plannedDate, setPlannedDate] = useState(null);
  const [completionDate, setCompletionDate] = useState(null);
  const [actualCompletionDate, setActualCompletionDate] = useState(null);
  const [priority, setPriority] = useState("Medium");
  const [assignees, setAssignees] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [labels, setLabels] = useState("");
  const [description, setDescription] = useState("");
  const [subtasks, setSubtasks] = useState("");
  const [file, setFile] = useState(null); 


  const adminID = localStorage.getItem("adminID");


  // Handle input changes
  const handleLabelsChange = (e) => {
    setLabels(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleSubtasksChange = (e) => {
    setSubtasks(e.target.value);
  };


  useEffect(() => {
    if (adminID) {
      axios
        .get(`${baseurl}getAssigneesByOrgId/${adminID}`)
        .then((res) => {
          console.log("Response data:", res.data);

          if (res.data?.assignees?.length) {
            const formatted = res.data.assignees.map((item) => {
              const firstLetter = item.full_name.charAt(0).toUpperCase();
              const profileImageUrl = item.profile_image
                ? `${imageUrl}assignee/${item.profile_image}`
                : null;

              return {
                label: item.full_name,  // Using the name for the label
                value: item.id,
                profileImageUrl: profileImageUrl,  // Storing image URL for use in the option renderer
              };
            });

            setAssignees(formatted); // Update state with formatted assignees
          }
        })
        .catch((err) => console.error("Failed to fetch assignees", err));
    }
  }, [adminID]);

  // Custom option renderer for react-select
  const customSingleValue = ({ data }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {data.profileImageUrl ? (
        <img
          src={data.profileImageUrl}
          alt={data.label} className="mx-2"
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            marginRight: '10px', marginLeft : '20px',
          }}
        />
      ) : (
        <div
          style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: '#007bff',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '10px',
          }}
        >
          {data.label.charAt(0).toUpperCase()}
        </div>
      )}
      {data.label}
    </div>
  );

  const customOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
        {data.profileImageUrl ? (
          <img
            src={data.profileImageUrl}
            alt={data.label}
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              marginRight: '10px', marginLeft : '10px', cursor: 'pointer'
            }}
          />
        ) : (
          <div
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              backgroundColor: '#007bff',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '10px', marginLeft : '10px',  cursor: 'pointer'
            }}
          >
            {data.label.charAt(0).toUpperCase()}
          </div>
        )}
        {data.label}
      </div>
    );
  };

  
  

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("assignees", JSON.stringify(selectedAssignees.map((a) => a.value)));
    formData.append("plannedDate", plannedDate ? plannedDate.toISOString().split("T")[0] : "");
    formData.append("completionDate", completionDate ? completionDate.toISOString().split("T")[0] : "");
    formData.append("actualCompletionDate", actualCompletionDate ? actualCompletionDate.toISOString().split("T")[0] : "");
    
    formData.append("priority", priority);
    formData.append("labels", labels);
    formData.append("description", description);
    formData.append("subtasks", subtasks);
    formData.append("adminId", adminID);
  
    // Append the file if it's selected
    if (file) {
      formData.append("file", file);
    }
  
    // Log the data being sent in the FormData
    const formDataLog = {};
    formData.forEach((value, key) => {
      if (value instanceof File) {
        formDataLog[key] = `File: ${value.name} (size: ${value.size} bytes)`;
      } else {
        formDataLog[key] = value;
      }
    });
  
    // Log file separately
    if (file) {
      console.log("File appended to FormData:", file.name, file.size);
    }
  
    console.log("FormData being sent:", formDataLog);
  
    try {
      const res = await axios.post(`${baseurl}createProjectManagement`, formData);
      
      // Success toast notification
      toast.success("Project created successfully");
      window.location.reload();
      // Optional: clear form or close modal
    } catch (error) {
      console.error("Project creation failed", error);
      
      // Error toast notification
      toast.error("Something went wrong!");
    }
  };
  
  
  
  

  return (
    <>
      <button
        className="new-project-btn"
        data-bs-toggle="modal"
        data-bs-target="#newProjectModal"
        
      >
        <Plus />
        &nbsp;New Project
      </button>

      <div
        className="modal fade"
        id="newProjectModal"
        tabIndex="-1"
        aria-labelledby="newProjectModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="newProjectModalLabel">
                Create New Project
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                {/* Assignees */}
                <div className="mb-3">
                  <label htmlFor="assignees" className="form-label text-start w-100">
                    Users
                  </label>
                  <Select
        options={assignees}
        value={selectedAssignees}
        onChange={setSelectedAssignees}
        getOptionLabel={(e) => e.label} // Use `label` for display text
        components={{ SingleValue: customSingleValue, Option: customOption }}
        isMulti
        className="w-100 text-start"
        labelledBy="Select Assignees"
      />
                </div>

                {/* Planned Completion Date */}
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label htmlFor="plannedDate" className="form-label text-start w-100">
                      Planned Completion Date
                    </label>
                    <DatePicker
                      id="plannedDate"
                      selected={plannedDate}
                      onChange={(date) => setPlannedDate(date)}
                      className="form-control w-100"
                      placeholderText="📅 Planned date"
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>

                  {/* Completion Date */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="completionDate" className="form-label text-start w-100">
                      Completion Date
                    </label>
                    <DatePicker
                      id="completionDate"
                      selected={completionDate}
                      onChange={(date) => setCompletionDate(date)}
                      className="form-control w-100"
                      placeholderText="📅 Completion date"
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>

                  {/* Actual Completion Date */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="actualCompletionDate" className="form-label text-start w-100">
                      Actual Completion Date
                    </label>
                    <DatePicker
                      id="actualCompletionDate"
                      selected={actualCompletionDate}
                      onChange={(date) => setActualCompletionDate(date)}
                      className="form-control w-100"
                      placeholderText="📅 Actual completion date"
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                </div>

                {/* Priority */}
                <div className="mb-3">
                  <label htmlFor="priority" className="form-label text-start w-100">
                    Set Priority
                  </label>
                  <select
                    id="priority"
                    className="form-select"
                    value={priority}
                    onChange={(e) => setPriority(e.target.value)}
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                </div>

                {/* Labels */}
                <div>
      {/* Labels Input */}
      <div className="mb-3">
        <label htmlFor="labels" className="form-label text-start w-100">
          Labels
        </label>
        <input
          type="text"
          className="form-control"
          id="labels"
          placeholder="🏷️ Enter labels (comma separated)"
          value={labels}
          onChange={handleLabelsChange} // On change handler
        />
      </div>

      {/* Description Textarea */}
      <div className="mb-3">
        <label htmlFor="description" className="form-label text-start w-100">
          Project Description
        </label>
        <textarea
          className="form-control"
          id="description"
          rows="3"
          placeholder="📝 Project description"
          value={description}
          onChange={handleDescriptionChange} // On change handler
        ></textarea>
      </div>

      {/* Subtasks Textarea */}
      {/* <div className="mb-3">
        <label htmlFor="subtasks" className="form-label text-start w-100">
          Subtasks
        </label>
        <textarea
          className="form-control"
          id="subtasks"
          rows="3"
          placeholder="✅ Subtasks (for Multiple add comma separated )"
          value={subtasks}
          onChange={handleSubtasksChange} // On change handler
        ></textarea>
      </div> */}
    </div>
                {/* File Attachment */}
                <div className="mb-3">
                  <label htmlFor="fileAttachment" className="form-label text-start w-100">
                    File Attachment / Logo
                  </label>
                  
                  <input
  type="file"
  className="form-control"
  id="fileAttachment"
  onChange={(e) => setFile(e.target.files[0])}
/>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button> */}
              <button type="submit" className="btn-sm custom-btn green" onClick={handleSubmit}>
                Save Project
              </button>
            </div>
          </div>
        </div>

        <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"  // Colored theme for toasts
      />


      </div>
    </>
  );
};

export default AddProjectManagement;
